import React, { Fragment } from "react";
import {
  Container,
  Paper,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import swal from "sweetalert";
import * as dataApi from "../../api/dataApi";

class DataImport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      open: false,
      response: {},
    };
  }

  handleChange = (acceptedFiles) => {
    this.setState({ files: acceptedFiles });
  };

  handleUpload = async () => {
    const { files } = this.state;
    if (files.length) {
      const response = await dataApi.dataImport(files);
      if (response) {
        if (response.status === "Success") {
          swal({
            title: "Opplastingen er vellykket!",
            icon: "success",
          });
        } else if (response.status === "Fail") {
          this.setState({
            open: true,
            response,
          });
        }
      } else {
        swal({
          title: "Opplastingen er mislykket!",
          text: "Teknisk feil. Kontakt administrator.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
      toast.error("Velg en fil..");
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { response, open } = this.state;

    const tableHeaderDark = {
      backgroundColor: "#e6e6e6",
      fontWeight: "bold",
      fontSize: 16,
    };

    const tableHeaderLight = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 14,
    };

    return (
      <Container maxWidth="lg">
        <main style={{ width: "90%", paddingTop: 100, margin: "auto" }}>
          <Paper style={{ width: "100%", padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h2>Import av skadebehandlingsdata fra eksternt system:</h2>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 20 }}>
                <Dropzone onDrop={this.handleChange} />
              </Grid>
              <Grid item xs={12} style={{ marginTop: 30, marginBottom: 20 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handleUpload}
                >
                  Last opp
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Dialog open={open} onClose={this.handleClose} fullWidth>
                  <DialogTitle>
                    {`Totalt ${response.totalRowsOfData || 0} rader, ${response.successfulRows || 0
                      } rader er importert`}
                  </DialogTitle>
                  <DialogContent>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={tableHeaderDark}>Rad</TableCell>
                            <TableCell style={tableHeaderDark}>Sak nr.</TableCell>
                            <TableCell style={tableHeaderDark} align="center">
                              Detaljer
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={tableHeaderLight}></TableCell>
                            <TableCell style={tableHeaderLight}></TableCell>
                            <TableCell colSpan={3} style={tableHeaderLight}>
                              Feilmeldinger
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.keys(response).length !== 0 &&
                            response.failedRows.map((row) => (
                              <TableRow key={row.rowNr}>
                                <TableCell>{row.rowNr}</TableCell>
                                <TableCell>{row.comment}</TableCell>
                                {Object.keys(row.fieldErrors).length !== 0 ? (
                                  row.fieldErrors.map((error, index) => (
                                    <Fragment key={index}>
                                      <TableRow>
                                        <TableCell>{error.fieldNr}</TableCell>
                                        <TableCell>{error.fieldName}</TableCell>
                                        <TableCell>{error.errorMessage}</TableCell>
                                      </TableRow>
                                    </Fragment>
                                  ))
                                ) : (
                                  <Fragment>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                  </Fragment>
                                )}
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                      Avbryt
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </Container>
    );
  }
}

function Dropzone({ onDrop }) {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDrop,
    accept: [".xls", ".xlsx", ".txt", ".csv"],
    maxFiles: 50,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: "2px dashed #aaa",
        padding: 4,
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body1">
        Dra og slipp filer her eller klikk for å velge filer
      </Typography>
      {acceptedFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1">Valgte filer:</Typography>
          <ul>
            {acceptedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
}

export default DataImport;
